import { formatDateToDDMMYYYY } from "@utils/date-time";
import { formatInstant } from "../utils/formatInstant";

const group = (value: number, min: number, max: number) =>
  value.toLocaleString("en-US", { minimumFractionDigits: min, maximumFractionDigits: max });

/** DBCO-0059 - display formatting only: the report's figures come from the API and are never computed here. */
export const formatQuantity = (value: number | null | undefined): string =>
  value === null || value === undefined ? "-" : group(value, 2, 2);

export const formatSurvey = (value: number | null | undefined): string =>
  value === null || value === undefined ? "-" : group(value, 3, 3);

export const formatWater = (value: number | null | undefined): string =>
  value === null || value === undefined ? "-" : group(value, 0, 3);

export const formatWhole = (value: number | null | undefined): string =>
  value === null || value === undefined ? "-" : group(value, 0, 0);

export const formatHours = (value: number | null | undefined): string => formatQuantity(value);

export const formatReportDate = (isoDate: string | null | undefined): string =>
  isoDate ? formatDateToDDMMYYYY(isoDate) : "-";

export const columnLabel = (column: { cargoCode: string; gradeSizeCode: string }): string =>
  `${column.cargoCode} ${column.gradeSizeCode}`;

export const sameColumn = (
  left: { cargoCode: string; gradeSizeCode: string },
  right: { cargoCode: string; gradeSizeCode: string },
): boolean => left.cargoCode === right.cargoCode && left.gradeSizeCode === right.gradeSizeCode;

/** An instant as its Asia/Dubai date and time, for grids that show them in two columns; a missing instant is two dashes. */
export const splitInstant = (iso: string | null | undefined): { date: string; time: string } => {
  const [date, time] = formatInstant(iso).split(", ");
  return { date: date ?? "-", time: time ?? "-" };
};
